const planBehaviorIds = {
    CanAddPlanParts: 'CanAddPlanParts',
    CanBulkSchedulePlans: 'CanBulkSchedulePlans',
    ShowPublicFundingOnPlan: 'ShowPublicFundingOnPlan',
    CanOverrideBillingScheme: 'CanOverrideBillingScheme',
    ShowPlanPublicFundingNotices: 'ShowPlanPublicFundingNotices',
    CanSavePlan: 'CanSavePlan',
    CanDeletePlan: 'CanDeletePlan',
    ShowPlanWarnings: 'ShowPlanWarnings',
    CanSetPFRateOnPlan: 'CanSetPFRateOnPlan',
    CanSetPFTotalOnPlan: 'CanSetPFTotalOnPlan',
    CanSavePublicFunding: 'CanSavePublicFunding',
    CanAddDailyDiscounts: 'CanAddDailyDiscounts',
};

export default planBehaviorIds;
